// extracted by mini-css-extract-plugin
module.exports = {"notes":"BasicDetailsCard_notes__402-Y","notesText":"BasicDetailsCard_notesText__23scL","checkboxSelection":"BasicDetailsCard_checkboxSelection__2-hGP"};